import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  cardContainer: {
    width: '100%',
    height: '100%',
    maxHeight: '350px',
    marginRight: 8,
    zIndex: 1,
    borderRadius: 30,
    overflow: 'hidden',
    position: 'relative',

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '100%',
      background: 'linear-gradient(0deg, rgba(2,0,36,0.5) 0%, rgba(40,145,179,0) 40%, rgba(0,212,255,0) 100%)',
      borderRadius: 30,
      pointerEvents: 'none',
    },
    cursor: 'pointer',
  },
  img: {
    borderRadius: 30,
    transition: 'transform 0.5s',
    objectFit: 'cover',
    cursor: 'pointer',

    '&:hover': {
      transform: 'scale(1.1)',
    }
  },
  cardContainerText: {
    position: 'absolute',
    cursor: 'pointer',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '10px',
    color: 'white',
    zIndex: 20,
  },
  card: {
    marginRight: 8,
    height: '100%',
    width: '100%',
    boxShadow: '-1px 6px 14px 1px rgba(0,0,0,0.27)',
  },
  containerCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    height: '100%',
    width: '100%',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 300,
    gap: 10,
    padding: 10,
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    flexWrap: 'wrap',
  },
  title: {
    margin: 0,
    textAlign: 'start',
    marginBottom: 10,
  },
  more: {
    color: '#98A2AE !important',
    padding: '3px 6px !important',
    minWidth: 'unset !important',
    backgroundColor: '#E8EBED !important',
    '&:hover': {
      backgroundColor: '#d9dadb !important',
    }
  },
  activities: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 5,
  },
  btnGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  large: {
    width: '100%',
    height: 150,
  },
}))
